import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const ProductsComponent = lazy(() => import('./products.tsx'));

export const productsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <ProductsComponent />
      </Suspense>
    )
  }
];
